import { isNullOrEmpty } from './is-null-or-empty';

export function deepCopy<T>(obj: T): T | null {
  if (isNullOrEmpty(obj)) {
    return null;
  }

  return JSON.parse(JSON.stringify(obj));
}
